import { render, staticRenderFns } from "./WebsiteGeneral.vue?vue&type=template&id=024f7c44&"
import script from "./WebsiteGeneral.vue?vue&type=script&lang=js&"
export * from "./WebsiteGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024f7c44')) {
      api.createRecord('024f7c44', component.options)
    } else {
      api.reload('024f7c44', component.options)
    }
    module.hot.accept("./WebsiteGeneral.vue?vue&type=template&id=024f7c44&", function () {
      api.rerender('024f7c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/WebsiteGeneral.vue"
export default component.exports